exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-obc__facts[data-v-0c1d22bf]{display:flex;flex-wrap:wrap;gap:8px 24px;margin:0 0 14px}.pi-obc__fact dt[data-v-0c1d22bf]{font-size:11px;font-weight:700;color:#4e5560;text-transform:uppercase}.pi-obc__fact dd[data-v-0c1d22bf]{margin:0;font-size:13px;color:#1f2933}.pi-obc__cards[data-v-0c1d22bf]{margin-top:14px}.pi-obc__hint[data-v-0c1d22bf]{margin:0;font-size:12px;color:#6b7280}.pi-obc__note[data-v-0c1d22bf]{margin:0 0 8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c1d22bf","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/components/pi/piOnboardingCompany.vue
// module id = 1752
// module chunks = 0